/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { GlobalDeploymentTemplateInfo } from '@modules/cloud-api/v1/types'

import { FETCH_GLOBAL_DEPLOYMENT_TEMPLATES } from '../constants/actions'

import type { AsyncAction, ReduxState } from '@/types/redux'

export type State = GlobalDeploymentTemplateInfo[] | null

interface FetchAllAction
  extends AsyncAction<typeof FETCH_GLOBAL_DEPLOYMENT_TEMPLATES, GlobalDeploymentTemplateInfo[]> {}

export default function globalDeploymentTemplatesReducer(
  state: State = null,
  action: FetchAllAction,
): State {
  if (action.type === FETCH_GLOBAL_DEPLOYMENT_TEMPLATES) {
    if (!action.error && action.payload) {
      return action.payload
    }
  }

  return state
}

function _getGlobalDeploymentTemplates(state: State) {
  return state
}

export const getGlobalDeploymentTemplates = (state: ReduxState) =>
  _getGlobalDeploymentTemplates(state.globalDeploymentTemplates)
